import FetchWrapper from "./FetchWrapper";

export const GetSubjects = () => {
  return fetchApi("/subjects")
}

export const CreateSubject = (subject) => {
  return fetchApi('/subjects', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const UpdateSubject = (id, subject) => {
  return fetchApi(`/subjects/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const DeleteSubject = (id) => {
  return fetchApi(`/subjects/${id}`, { method: 'DELETE' })
}